import React from "react";
import { BLOGS } from "../../constants/BlogConstant";
import { getTags } from "../../utils/blogUtils";
import { useNavigate } from "react-router-dom";

type TagProps = {
  selectedTag?: string | null;
  handleFilterByTag?: (category: string) => void;
};

const Tag: React.FC<TagProps> = ({ selectedTag, handleFilterByTag }) => {
  const tags = getTags(BLOGS);
  const navigate = useNavigate();

  const handleClick = (tag: string) => {
    if (handleFilterByTag) {
      handleFilterByTag(tag);
    }
    navigate(`/blogs?tag=${encodeURIComponent(tag)}`);
  };

  return (
    <div className="single-widgets widget_egns_tag">
      <div className="widget-title">
        <h4>Tags</h4>
      </div>
      <p className="wp-block-tag-cloud">
        {tags.map((tag, index) => (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleClick(tag);
            }}
             className={selectedTag === tag ? "active" : ""}
            >
            {tag}
          </a>
        ))}
      </p>
    </div>
  );
};

export default Tag;
